<template>
  <v-container fluid>
    <PageHeading
      mode="grid"
      :text="'Общий доступ'"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
       <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          @click="formDialogVisible = true"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Дать общий доступ
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridSharedAccess
          ref="grid"
          :formDialogVisible="formDialogVisible"
          @close="formDialogVisible = false"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridSharedAccess from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageSharedAccess',
  components: {
    PageHeading,
    GridSharedAccess
  },
  metaInfo () {
    return {
      title: 'Общий доступ'
    }
  },
  mixins: [gridPageInterface],
  data () {
    return {
      formDialogVisible: false
    }
  },
  methods: {
    submit () {
      this.refetchForm = true
    }
  }
}
</script>
